module.exports = __webpack_public_path__ + "static/media/SWT_02.67d43647.jpeg";